import { render, staticRenderFns } from "./RecaptchaDisabled.vue?vue&type=template&id=70f92644"
import script from "./RecaptchaDisabled.vue?vue&type=script&lang=ts"
export * from "./RecaptchaDisabled.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports